import ContextSnackbar from 'Components/Snackbar';
import { HeadingTwo } from 'Components/Headings';
import AdminOrderHistoryTable from 'Pages/SuperAdmin/AdminOrderHistory/AdminOrderHistoryTable';
import React, { useState } from 'react';
import styled from 'styled-components';
import { displayFlex } from '../../../styles/Mixins';
import { paragraphReg } from '../../../styles/Typography';
import colors from '../../../styles/Colors';
import { ADMIN_ORDER_HISTORY_BY_ORDER_ID } from 'Queries/SuperAdmin/AdminOrderHistory';
import { useLazyQuery } from '@apollo/react-hooks';

function AdminOrderHistoryPage(props) {
  const { className } = props;
  const [orderId, setOrderId] = useState('');
  const [getAdminOrderHistory, { data, loading, error }] = useLazyQuery(ADMIN_ORDER_HISTORY_BY_ORDER_ID, {
    fetchPolicy: 'network-only'
  });

  const handleGetAdminOrderHistory = async () => {
    if (orderId) {
      await getAdminOrderHistory({
        variables: {
          input: {
            orderId: orderId
          }
        }
      });
    }
  };

  return (
    <>
      <div className={className}>
        <ContextSnackbar />
        <div className={`${className}__page-header`}>
          <div className={`${className}__header-wrapper`}>
            <HeadingTwo label="ADMIN ORDER HISTORY" />
          </div>
        </div>
      </div>
      <div className={className}>
        <div className={`${className}__page-body`}>
          <div className={`${className}__selector-container`}>
            <div className={`${className}__selector-item`}>
              <h3>OrderId</h3>
              <div className="order-input">
                <input type="number" onChange={e => setOrderId(e.target.value)} value={orderId} />
                <button type="primary" disabled={loading} onClick={handleGetAdminOrderHistory}>
                  search
                </button>
              </div>
            </div>
            <div>
              <AdminOrderHistoryTable
                orderHistory={data?.adminOrderHistory ? [...data.adminOrderHistory].sort((a, b) => +a.id - +b.id) : []}
                loading={loading}
                error={error}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const SuperAdminOrderHistory = styled(AdminOrderHistoryPage)`
  &&& {
    ${displayFlex}
    align-items: center;
    width: 100%;
    height: auto;
    padding: 12px 0 11px 20px;
    ${paragraphReg}
    font-size: 14px;
    text-align: left;
    background-color: ${colors.background.primary};
    color: ${colors.text};
    border-radius: 3px;
  }

  &__page-header {
    text-align: left;
    width: 100%;
    border-bottom: 1px solid rgb(200, 214, 229);
    &&& {
      margin: 65px 0 25px;
    }
  }

  &__page-body {
    text-align: left;
    width: 100%;
    &&& {
      margin: 0;
      padding: 10px;
    }

    h3 {
      text-transform: uppercase;
      font-family: IBMPlexSans-Bold;
      font-size: 12px;
      font-weight: 400;
      color: rgb(79, 93, 109);
      margin-top: 0px;
      margin-bottom: 3px;
    }
  }

  &__selector-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__selector-item {
    margin-bottom: 10px;
  }

  &__page-body-child {
    margin-top: 20px;
  }

  &__header-wrapper {
    margin: 20px 0px !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .MuiInputBase-root {
    border: ${colors.text.lightGray2} 1px solid;
    border-radius: 3px;
    padding: 0 10px;
    min-width: 300px;
  }

  .MuiSvgIcon-root {
    width: 0.8em;
    height: 0.8em;
  }

  .MuiIconButton-root {
    padding-top: 6px;
  }

  .line {
    background: ${colors.border.primary};
    height: 1px;
    flex: 1;
    position: relative;
    top: 11px;
  }
`;

export default SuperAdminOrderHistory;
